import { useState, useEffect } from "react";

const useScrollValue = (): number => {
  const [scrollValue, setScrollValue] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollValue(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return scrollValue;
};

export default useScrollValue;
